import React from "react";
import { useContext } from "react";
import { I18nReactContext } from "../../../../../contexts/I18nContext";
import { get } from "lodash";
import { InstructionModal } from "../../../Shared/InstructionModal/InstructionModal";

/**
 * SurveyInstructionModal Component
 * Displays instructions and information before starting a survey
 * 
 * @param {object} props - Component props
 * @param {boolean} props.open - Whether the modal is open
 * @param {Array} props.sessionQuestions - Array of survey questions
 * @param {object} props.survey - Survey configuration object
 * @param {boolean} props.questionsLoaded - Whether questions have been loaded
 * @param {Function} props.onStartSurvey - Callback when starting survey
 * @returns {JSX.Element} The SurveyInstructionModal component
 */
export const SurveyInstructionModal = ({ 
    open, 
    sessionQuestions, 
    survey, 
    questionsLoaded, 
    onStartSurvey 
}) => {
    const { i18n } = useContext(I18nReactContext);
    
    const numberOfQuestions = get(sessionQuestions, 'length', 0);
    const isAnonymous = get(survey, 'questionnaireSession.isAnonymous', false);

    return (
        <InstructionModal
            open={open}
            title={i18n.translate('surveyInstruction.title')}
            footerText={i18n.translate('surveyInstruction.thankYou')}
            buttonText={String(i18n.translate('surveyInstruction.startButton'))}
            onButtonClick={onStartSurvey}
            buttonDisabled={!questionsLoaded}
            loading={!questionsLoaded}
        >
            <ul className="instruction-list">
                <li>{i18n.translate('surveyInstruction.info1', {context: {numberOfQuestions}})}</li>
                <li>{i18n.translate('surveyInstruction.info2')}</li>
                {get(survey, 'questionnaireSession.donotForceCompletion', false) && <li>{i18n.translate('surveyInstruction.info3')}</li>}
                <li>{i18n.translate('surveyInstruction.info4')}</li>
            </ul>
            
            {isAnonymous && (
                <div className="anonymous-notice">
                    <div className="anonymous-icon">🔒</div>
                    <div className="anonymous-text">
                        <strong>{i18n.translate('surveyInstruction.anonymous')}</strong>
                        <p>{i18n.translate('surveyInstruction.anonymousNotice')}</p>
                    </div>
                </div>
            )}
        </InstructionModal>
    );
}; 